import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CreateJobForm from './CreateJobForm';
import ContentContainer from '../containers/ContentContainer';

import 'css/components/jobs/_EditJob.scss';

export default class EditJob extends Component {
  static propTypes = {
    job: PropTypes.object,
    jobs: PropTypes.array,
    router: PropTypes.object,
  };

  componentDidMount() {
    const { job, router } = this.props;
    if (job) {
      return;
    }

    router.replace('/');
  }

  render() {
    const { job, jobs } = this.props;
    if (!job) {
      return null;
    }

    return (
      <ContentContainer outerClassName="editJob">
        <div className="heading">Edit job</div>
        <CreateJobForm jobs={jobs} job={job} />
      </ContentContainer>
    );
  }
}
